const KEY = "menupro_admin_auth";

export const setAdminAuth = (u, p) => {
  localStorage.setItem(KEY, JSON.stringify({ u, p }));
};

export const getAdminAuth = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearAdminAuth = () => localStorage.removeItem(KEY);
